import { EnumListNames } from "../../../integrations/_components/Accounting/AccountingRules/ImportRulesEnumOptions";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    basicDataLoading: false,
    basicDataErrorMessage: null,
    errorMessage: null,
    displaySurveyModal: false,
    standardAccountMappings: null,
    accountingIdentifierMethods: null,
    preferredIdentifier: null,
    monthOptions: [],
    shopifyLocales: [],
};

const commonsSlice = createSlice({
    name: "Commons",
    initialState,
    reducers: {
        getAllCommonsRequest(state) {
            state.loading = true;
            state.errorMessage = null;
            state.displaySurveyModal = false;
        },
        getAllCommonsSuccess(state, action) {
            state.loading = false;
            state.displaySurveyModal = false;
            state.commonCountries = action.payload.countriesAndCurrencies.countries;
            state.commonCurrencies = action.payload.countriesAndCurrencies.countryCurrencies;
            state.salesRuleSelectors = {
                ...action.payload.salesRuleSelectors,
                [EnumListNames.ACCOUNTING_IDENTIFIER_FIELD]: action.payload.accountingIdentifierMethods.options,
            };
            state.asyncTaskStatuses = action.payload.asyncTaskStatusesDto;
            state.accountingIdentifierMethods = action.payload.accountingIdentifierMethods.options;
            state.bmfExchangeRateIsMissingNotification = action.payload.currentBMFExchangeRateIsMissingNotification;
            state.authDataTypes = action.payload.authDataTypes.authDataTypes;
            state.standardAccountMappings = action.payload.standardAccountMappings;
            state.applicationProperties = action.payload.applicationProperties;
            state.monthOptions = action.payload.monthOptions;
            state.shopifyLocales = action.payload.shopifyLocales ?? [];
        },
        getAllCommonsFailure(state, action) {
            state.loading = false;
            state.errorMessage = action.payload;
            state.commonCountries = null;
            state.commonCurrencies = null;
        },

        sendFeedbackMessageRequest(state) {
            state.loading = true;
            state.errorMessage = null;
        },
        sendFeedbackMessageSuccess(state) {
            state.loading = false;
            state.errorMessage = null;
            state.displaySurveyModal = !state.displaySurveyModal;
        },
        sendFeedbackMessageFailure(state, action) {
            state.loading = false;
            state.errorMessage = action.payload;
        },

        resetSurveyModal(state) {
            state.loading = false;
            state.errorMessage = null;
        },

        setErrorMessageMissingInput(state) {
            state.errorMessage = "Es wurde keine Nachricht eingetragen.";
        },

        toggleSurveyModal(state) {
            state.loading = false;
            state.errorMessage = null;
            state.displaySurveyModal = !state.displaySurveyModal;
        },

        fetchPreferredIdentifierMethodsRequest(state) {
            state.loading = true;
            state.accountingIdentifierMethods = null;
            state.preferredIdentifier = null;
            state.errorMessage = null;
        },
        fetchPreferredIdentifierMethodsSuccess(state, action) {
            state.loading = false;
            state.accountingIdentifierMethods = action.payload.accountingIdentifierMethods.accountingIdentifierMethods;
            state.preferredIdentifier = action.payload.preferredAccountingIdentifierMethod;
            state.errorMessage = null;
        },
        fetchPreferredIdentifierMethodsFailure(state, action) {
            state.loading = false;
            state.errorMessage = action.payload;
        },

        toggleBasicDataLoading(state) {
            state.basicDataLoading = !state.basicDataLoading;
        },

        setBasicDataErrorMessage(state, action) {
            state.basicDataErrorMessage = action.payload;
        },
    },
});

export default commonsSlice;
